module.exports = __webpack_public_path__ + "static/media/THREE.e09e89ab.png";